import { Fragment } from "@wordpress/element";
import { PanelBody, SelectControl } from '@wordpress/components';
import { InspectorControls, RichText } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

const Contact = {
  title: __('Contact'),
  description: __('Contact content block for the ABS theme'),
  icon: 'phone',
  attributes: {
    icon : {
      type: 'string',
    },
    title : {
      type:   'string',
    },
    contact : {
      type:   'string',
    },
    alt: {
      type: 'string',
      source: 'attribute',
      selector: 'img',
      attribute: 'alt',
      default: 'Contact',
    },
  },
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes, isSelected }) {
    const { icon, title, contact } = attributes;
    if(icon === undefined){
      setAttributes({ icon: 'team' });
    }
    const iconFileName = `contact_${icon}.png`;

    return (
      <Fragment>
        <div className={className}>
          <div className={"container"}>
            <div className={"row align-items-center"}>
              <div className={"col-sm-6 contact__img"}>
                <img src={`/modules/custom/abs_blocks/blocks/content-contact/img/${iconFileName}`} alt={ attributes.alt } />
              </div>
              <div className={"col-sm-6 contact__body"}>
                <RichText
                  tagName="h2"
                  value={ title }
                  placeholder={ __('Insert contact title') }
                  allowedFormats={[]}
                  onChange={nextTitle => setAttributes({ title: nextTitle })}
                />
                <RichText
                  tagName="p"
                  value={ contact }
                  placeholder={ __('Insert contact information') }
                  allowedFormats={['core/link']}
                  onChange={nextContact => setAttributes({ contact: nextContact })}
                />
              </div>
            </div>
          </div>
        </div>
        <InspectorControls>
          <PanelBody title={ __('Icon') }>
            <SelectControl
              label={ __( 'Choose an icon to display:' ) }
              value={ icon } // e.g: value = [ 'a', 'c' ]
              onChange={ ( value ) => {
                setAttributes({ icon: value });
              } }
              options={ [
                { value: 'female', label: __('Female') },
                { value: 'male', label: __('Male') },
                { value: 'team', label: __('Team') },
              ] }
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { icon, title, contact } = attributes;
    const iconFileName = (icon === undefined) ? `illu-contact.svg` : `contact_${icon}.png`;

    return (
      <div className={className}>
        <div className={"container"}>
          <div className={"row align-items-center"}>
            <div className={"col-sm-6 contact__img"}>
              <img src={`/modules/custom/abs_blocks/blocks/content-contact/img/${iconFileName}`} alt={ attributes.alt } />
            </div>
            <div className={"col-sm-6 contact__body"}>
              {title && (
                <RichText.Content tagName="h2" value={ title } />
              )}
              {contact && (
                <RichText.Content tagName="p" value={ contact } />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default Contact;
